import { ModelStatus } from '../types/enum/model-status';

export const modelDetailEnabledButtons = (
  modelStatus: ModelStatus
): {
  editLabels: boolean;
  editModelImages: boolean;
  executeTraining: boolean;
} => {
  switch (modelStatus) {
    case 'created':
      return {
        editLabels: true,
        editModelImages: false,
        executeTraining: false
      };

    case 'annotating':
      return {
        editLabels: true,
        editModelImages: true,
        executeTraining: false
      };

    case 'training':
      return {
        editLabels: false,
        editModelImages: false,
        executeTraining: false
      };

    case 'annotated':
    case 'available':
    case 'failed':
      return {
        editLabels: true,
        editModelImages: true,
        executeTraining: true
      };
  }
};
